import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import NavigatorMenu from './NavigatorMenu'
import { Link, useNavigate } from 'react-router-dom'
import NavigatorMenuItems from './NavigatorMenuItems'
import { useCallback, useEffect, useState } from 'react'
import { getSearchCategory } from '../../utils'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { searchAtom } from '../../recoil/atom/SearchAtom'
import { DebounceInput } from 'react-debounce-input'
import HeaderFormSearch from './HeaderFormSearch'
import LoginBtnModal from 'components/Login/loginBtnModalOther'
import useWindowSize from '../../utils/useWindowSize'
const HeaderHome = ({banner} : any) => {
  const [selectBanner, setSelectBanner] = useState("");
  
  
  useEffect(() => {
    if(banner){
      if(screen.availWidth > 768){
        setSelectBanner(`${process.env.REACT_APP_MEDIA_ENDPOINT}/${banner?.desktop}`)
      }else{
        setSelectBanner(`${process.env.REACT_APP_MEDIA_ENDPOINT}/${banner?.mobile}`)
      }
    }
  }, [banner])
  return (
    <div>
      <div>
        <header className="main-header header-style-one">
          <div className="header-upper">
            <div className="auto-container clearfix">
              <div className="pull-left logo-box">
                <div className="logo">
                  <a href="">
                    <img src="/assets/images/logo.png" className="top_logo" alt="" title="" />
                  </a>
                </div>
              </div>

              <div className="nav-outer clearfix">
                <div className="mobile-nav-toggler">
                  <span className="icon flaticon-menu"></span>
                </div>

                <NavigatorMenu />
              </div>
            </div>
          </div>

          <div className="sticky-header">
            <div className="auto-container clearfix">
              <div className="logo pull-left">
                <Link to="/">
                  <img src="/assets/images/logo-small.png" alt="" title="" />
                </Link>
              </div>

              <div
                className="mobile-nav-toggler sticky-mobile-nav-toggler"
                style={{
                  position: 'absolute',
                  right: '20px',
                  top: 25,
                  zIndex: 99,
                  fontSize: 36,
                }}>
                <span className="icon flaticon-menu"></span>
              </div>

              <div className="pull-right">
                <nav className="main-menu">
                  <div className="navbar-header"></div>

                  <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
                    <NavigatorMenuItems />
                  </div>
                </nav>

                <div className="outer-box clearfix">
                  <div className="btn-box">
                    <div className="btn-box">
                      <LoginBtnModal />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mobile-menu">
            <div className="menu-backdrop"></div>
            <div className="close-btn">
              <span className="icon flaticon-multiply"></span>
            </div>

            <nav className="menu-box mCustomScrollbar _mCS_1 mCS_no_scrollbar">
              <div
                id="mCSB_1"
                className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                tabIndex={0}
                style={{ maxHeight: '969px' }}>
                <div
                  id="mCSB_1_container"
                  className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                  style={{ position: 'relative', top: 0, left: 0 }}
                  dir="ltr">
                  <div className="nav-logo">
                    <Link to="/">
                      <img
                        src="/assets/images/logo-3.png"
                        alt=""
                        title=""
                        className="mCS_img_loaded"
                      />
                    </Link>
                  </div>
                  <div className="menu-outer">
                    <div className="navbar-header">
                      <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                      </button>
                    </div>

                    <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
                      <NavigatorMenuItems mobile={true} />
                    </div>

                    <div className="outer-box clearfix">
                      <div className="btn-box">
                        <div className="btn-box">
                          <LoginBtnModal />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="mCSB_1_scrollbar_vertical"
                  className="mCSB_scrollTools mCSB_1_scrollbar mCS-light mCSB_scrollTools_vertical"
                  style={{ display: 'none' }}>
                  <div className="mCSB_draggerContainer">
                    <div
                      id="mCSB_1_dragger_vertical"
                      className="mCSB_dragger"
                      style={{
                        position: 'absolute',
                        minHeight: '30px',
                        height: '0px; top: 0px',
                      }}>
                      <div className="mCSB_dragger_bar" style={{ lineHeight: '30px' }}></div>
                    </div>
                    <div className="mCSB_draggerRail"></div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </header>
      </div>

      <section className="banner-section-four">
        {selectBanner !== "" && (
        <OwlCarousel
          key={`header_banner_desktop_${Date.now()}`}
          className="main-slider-carousel owl-carousel owl-theme"
          mouseDrag={false}
          items={1}>
          <div className="item slide e1" style={{backgroundImage:`url(${selectBanner})`}}>
            {/* <div className="dotted-layer" style={{backgroundImage: `url(assets/images/main-slider/dotted-layer-1.png)`}}></div> */}
            <div className="auto-container">
              <div className="row clearfix">
                <div className="content-column col-lg-6 col-md-12 col-sm-12">
                  <div className="inner-column">
                    <h1 className="mo_h1">Smart Oryor</h1>
                    <div className="title mo_title">รวดเร็ว ปลอดภัย นำไทยสู่สากล</div>
                    <div className="newsletter-form">
                      <HeaderFormSearch />
                    </div>
                  </div>
                </div>

                <div className="image-column col-lg-6 col-md-12 col-sm-12"></div>
              </div>
            </div>
          </div>
        </OwlCarousel>)}

        <div>
          <svg
            className="waves"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto">
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
              <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
            </g>
          </svg>
        </div>
      </section>
    </div>
  )
}

export default HeaderHome
